export async function downloadAttachment(
  source: string,
  filename?: string
): Promise<void> {
  if (!filename) {
    window.open(source, '_blank', 'noopener,noreferrer');
    return;
  }

  const path = source.split(/[?#]/)[0];
  const dotIndex = path.lastIndexOf('.');
  const suffix =
    dotIndex > path.lastIndexOf('/') ? path.slice(dotIndex + 1) : '';
  if (suffix && !filename.toLowerCase().endsWith('.' + suffix.toLowerCase())) {
    filename += '.' + suffix;
  }

  let objectUrl: string | undefined;
  try {
    const response = await fetch(source);
    if (!response.ok) {
      throw new Error('Unable to download attachment');
    }
    objectUrl = URL.createObjectURL(await response.blob());
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = filename;
    link.click();
  } catch {
    window.open(source, '_blank', 'noopener,noreferrer');
  } finally {
    if (objectUrl) {
      URL.revokeObjectURL(objectUrl);
    }
  }
}
